import React from 'react';

/**
 * SiteLogo — renders the static site logo (public/logo.png).
 *
 * Props:
 *   className — applied to <img>
 *   forceDark / forceLight — accepted for call-site compatibility but
 *   unused; the logo has one static asset for both color themes.
 */
const SiteLogo = ({ className = '', forceDark, forceLight, alt = 'Logo', ...props }) => (
  <img src="/logo.png" alt={alt} className={className} {...props} />
);

export default SiteLogo;
